import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons/iconfont/material-icons.css'
import store from '../store'

// Translation provided by Vuetify (javascript)
// import zhHans from 'vuetify/es5/locale/zh-Hans'

import { en } from './i18n/en'
import { de } from './i18n/de'
import { es } from './i18n/es'
import { fr } from './i18n/fr'
import { it } from './i18n/it'
import { ja } from './i18n/ja'
import { pt } from './i18n/pt'
import { ru } from './i18n/ru'
import { th } from './i18n/th'
import { tr } from './i18n/tr'
import { zh } from './i18n/zh'

Vue.use(Vuetify)
export default new Vuetify({
  icons: {
    iconfont: 'md'
  },
  theme: {
    themes: {
      light: {
        primary: {
          base: '#2a40c3'
        },
        secondary: {
          base: '#4f3690'
        }
      }
    }
  },
  lang: {
    // eslint-disable-next-line standard/object-curly-even-spacing
    locales: {en, es, de, fr, it, ja, pt, ru, th, tr, zh },
    current: store.getters.getCurrentLanguage
  }
})



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js